import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  textField: {
    width: '100%',
    '&& .no-format:focus': {
      border: `0px solid ${capitalDesignTokens.semanticColors.interaction.focus}`,
      padding: '4px 10px'
    },
    '&& .no-format:hover': {
      border: 'none'
    }
  },
  characterCount: {
    color: capitalDesignTokens.foundations.colors.gray600,
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
  },
  countDefault: {
    color: capitalDesignTokens.foundations.colors.gray600
  },
  countError: {
    color: capitalDesignTokens.semanticColors.foreground.errorSmall
  },
  sheetsSection: {
    marginTop: '16px'
  },
  sectionTitle: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium,
    marginBottom: '8px'
  },
  sectionDescription: {
    marginTop: '16px',
    '& strong': {
      fontWeight: capitalDesignTokens.foundations.typography.fontWeight.medium
    }
  },
  confirmFileWarning: {
    marginBottom: '4px'
  }
});
